export default {
  user: {},
  cart: [],
  root: process.env.API_URL,
  auth: false,
  banner: false,
  token: localStorage.getItem('__token'),
  selectedCat: '',
  login: function (username, password, callback) {
    var self = this
    var loginData = {
      grant_type: 'password',
      username: username,
      password: password
    }
    $.ajax({
      type: 'POST',
      url: self.root + 'api/token',
      data: loginData
    }).done(function (data) {
      self.token = data.access_token
      self.auth = true
      // Cache the access token in session storage.
      localStorage.setItem('__token', data.access_token)
      callback(true, data)
    }).fail(function (message) {
      console.log('error')
      callback(false, message)
    })
  },
  // get: function (url, data, callback) {
  //   this.http.get(this.root + url, data,
  //     {
  //       headers: {
  //         'Authorization': 'Bearer ' + this.token
  //       }
  //     })
  //     .then(
  //       function (response) {
  //         var success = response.ok
  //         callback(success, response.data)
  //       },
  //     function (response) {
  //       callback(false, response)
  //     }
  //   )
  // },
  // post: function (url, data, callback) {
  //   this.http.post(this.root + url, data,
  //     {
  //       headers: {
  //         'Authorization': 'Bearer ' + this.token
  //       }
  //     })
  //   .then(
  //     function (response) {
  //       callback(true, response.data.Response)
  //     },
  //     function (response) {
  //       callback(false, response)
  //     }
  //   )
  // }
  checkAuth () {
    if (this.token !== null) {
      var self = this
      $.ajax({
        type: 'GET',
        url: self.root + 'api/account',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + self.token)
        }
      }).done(function () {
        self.auth = true
      }).fail(function () {
        localStorage.removeItem('__token')
      })
    }
  },
  checkBanner () {
    var self = this
    $.ajax({
      type: 'GET',
      url: self.root + 'api/AdminConfigs'
    }).done(function (response) {
      for (var i = 0; i < response.length; i++) {
        if (response[i].Enabled) {
          self.banner = response[i]
        }
      }
    }).fail(function () {
      self.banner = false
    })
  },
  logout () {
    var self = this
    localStorage.removeItem('__token')
    self.token = null
    self.auth = false
    location.reload(true)
  },
  isLoggedIn () {
    if (localStorage.getItem('__token')) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store.js